import { ServiceIcon, type ServiceIconName } from "./service-icons";

const locationStatIcons = {
  "Uplink Capacity": { icon: "network" as ServiceIconName, tone: "violet" as const },
  Optimized: { icon: "rocket" as ServiceIconName, tone: "green" as const },
};

const productLocations = [
  {
    code: "LAX1",
    city: "Los Angeles",
    image: "/images/loc-lax.jpg",
    copy: "Los Angeles hosting near One Wilshire, with access to major carriers and trans-Pacific connectivity.",
    stats: [
      { value: "120Gbps", label: "Uplink Capacity" },
      { value: "Globally", label: "Optimized" },
    ],
  },
  {
    code: "HKG1",
    city: "Hong Kong",
    image: "/images/loc-hkg.jpg",
    copy: "Hong Kong hosting for applications serving users in mainland China and Southeast Asia.",
    stats: [
      { value: "80Gbps", label: "Uplink Capacity" },
      { value: "Asia", label: "Optimized" },
    ],
  },
  {
    code: "TYO1",
    city: "Tokyo",
    image: "/images/loc-tyo.jpg",
    copy: "Tokyo hosting for applications serving Japan and other East Asian markets.",
    stats: [
      { value: "100Gbps", label: "Uplink Capacity" },
      { value: "Asia", label: "Optimized" },
    ],
  },
];

export function LocationCards({ id }: { id?: string }) {
  return (
    <section className="product-section product-locations" id={id}>
      <div className="location-grid">
        {productLocations.map((loc) => (
          <article className="location-card" key={loc.code}>
            <div className="location-media" style={{ backgroundImage: `url(${loc.image})` }}>
              <span className="location-badge">{loc.code}</span>
              <h3 className="location-name">{loc.city}</h3>
            </div>
            <div className="location-body">
              <p>{loc.copy}</p>
              <div className="location-stats">
                {loc.stats.map((stat) => {
                  const meta = locationStatIcons[stat.label as keyof typeof locationStatIcons];
                  return (
                    <div className={`location-stat${meta ? ` location-stat-${meta.tone}` : ""}`} key={stat.label}>
                      {meta ? <ServiceIcon name={meta.icon} tone={meta.tone} /> : null}
                      <div>
                        <b>{stat.value}</b>
                        <span>{stat.label}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
